import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { JobTemplate } from 'src/app/core/models/job';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class JobTemplateService {

  private apiUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'JobInfoes/jobtemplates';

  constructor(private http: HttpClient, private env: EnvironmentService,) { }

  getJobTemplate(templateId: string): Observable<JobTemplate> {
    const url = `${this.apiUrl}/${templateId}`;
    return this.http.get<JobTemplate>(url);
  }

  createJobTemplate(jobTemplate: JobTemplate): Observable<JobTemplate> {
    const url = `${this.apiUrl}/Deployment/${jobTemplate.deploymentId}/add`;
    return this.http.post<JobTemplate>(url, jobTemplate);
  }

  updateJobTemplate(jobTemplate: JobTemplate): Observable<JobTemplate> {
    const url = `${this.apiUrl}/update/${jobTemplate.templateId}`;
    return this.http.put<JobTemplate>(url, jobTemplate);
  }

  deleteJobTemplate(templateId: string): Observable<void> {
    const url = `${this.apiUrl}/delete/${templateId}`;
    return this.http.delete<void>(url);
  }

  getJobTemplates(depName: string = "all"): Observable<JobTemplate[]> {
    if(depName == null || depName == ""){
      depName = "all";
    }
    const url = `${this.apiUrl}/Deployment/${depName}`;
    return this.http.get<JobTemplate[]>(url);
  }

  getJobTemplateByName(templateName: string, applicationName:string, depName: string = "all"): Observable<JobTemplate | null> {
    return this.getJobTemplates(depName).pipe(
      map(templates => templates.find(template => template.templateName == templateName && template.application == applicationName) || null)
    );
  }

  checkIfJobTemplateExists(templateName: string, applicationName: string, depName: string = "all"): Observable<boolean> {
    return this.getJobTemplateByName(templateName, applicationName, depName).pipe(
      map(template => template !== null),
      catchError(error => of(false))
    );
  }
}
